import { useEffect, useState } from 'react';

const SUPPORTED_LANGUAGES = new Set(['zh-CN', 'en-US']);

function initialLanguage() {
  try {
    const saved = localStorage.getItem('vnext-language');
    if (SUPPORTED_LANGUAGES.has(saved)) return saved;
  } catch {
    // Fall back to Chinese when storage is unavailable.
  }
  return 'zh-CN';
}

export default function useLanguage() {
  const [language, setLanguage] = useState(initialLanguage);

  useEffect(() => {
    document.documentElement.lang = language;
    try {
      localStorage.setItem('vnext-language', language);
    } catch {
      // The language switch still works for the current session.
    }
  }, [language]);

  return { language, setLanguage };
}
